import * as React from 'react';
import {
	Box,
	Typography,
	Paper,
	TextField,
	Button,
	Grid,
	CircularProgress
} from '@mui/material';
import ArrearsTable from '../../../components/Tables/ArrearsTable';
import { useGetPropertyArrears } from 'services/hooks/rentals';
import { useSelector } from 'react-redux';

export default function RentArrears() {
	const propertyId = useSelector((state) => state.property_id);
	const [selectedDate, setSelectedDate] = React.useState(new Date().toISOString().split('T')[0]);
	const { arrearsData, isLoadingArrearsData, errorArrearsData } = useGetPropertyArrears(
		propertyId,
		selectedDate
	);

	const handleDateChange = (event) => {
		setSelectedDate(event.target.value);
	};

	return (
		<Box m="20px">
			<Grid container spacing={3}>
				<Grid item xs={12}>
					<Typography variant="h2" fontWeight="bold" gutterBottom>
						Rent Arrears Report
					</Typography>
					<Typography variant="body1" color="text.secondary" gutterBottom>
						View rent arrears as of a specific date
					</Typography>
				</Grid>

				<Grid item xs={12}>
					<Paper sx={{ p: 3, mb: 3 }}>
						<Grid container spacing={2} alignItems="center">
							<Grid item>
								<Typography variant="h6" gutterBottom>
									Select Arrears Date:
								</Typography>
							</Grid>
							<Grid item>
								<TextField
									type="date"
									value={selectedDate}
									onChange={handleDateChange}
									size="small"
									sx={{ minWidth: 200 }}
									InputLabelProps={{
										shrink: true,
									}}
								/>
							</Grid>
							<Grid item>
								<Typography variant="body2" color="text.secondary">
									Currently showing arrears as of: {new Date(selectedDate).toLocaleDateString()}
								</Typography>
							</Grid>
						</Grid>
					</Paper>
				</Grid>

				<Grid item xs={12}>
					{isLoadingArrearsData ? (
						<Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
							<CircularProgress />
						</Box>
					) : errorArrearsData ? (
						<Paper sx={{ p: 3, textAlign: 'center' }}>
							<Typography color="error" variant="h6">
								Error loading arrears data. Please try again.
							</Typography>
						</Paper>
					) : (
						<ArrearsTable 
							rows={arrearsData.arrears_records || []} 
							summary={arrearsData.summary || {}} 
						/>
					)}
				</Grid>
			</Grid>
		</Box>
	);
} 